import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { setDocTitle } from "../../../functions/HelperFuncs";
import Vue from "vue";
import { setup } from "../../../main";

export default {
  data() {
    return {
      homePage: "spaces",
      company: this.$store.state.company,
      home_logo: "",
      home_screen: "",
      error: "",
      imageStyle: { opacity: 0 },
      imageStyleLogo: { opacity: 0 },
      imageStyleLogo2: { opacity: 0 },
    };
  },
  created() {
    setDocTitle("pwa", this);

    EventBus.$on("pwa", (data) => {
      if (this.checkIfForHere(data.id)) {
        this.submit();
      }
    });
  },
  methods: {
    checkIfForHere(name) {
      return name === "pwa";
    },
    checkBilling($company) {
      if (
        $company == "poa" ||
        $company == "ethnicraft" ||
        $company == "hedgren" ||
        $company == "alimento" ||
        $company == "sheprd"
      ) {
        return 0;
      } else {
        return 1;
      }
    },
    submit() {
      const data = {};
      const formData = new FormData(this.$refs.pwaForm);

      formData.forEach((value, key) => (data[key] = value));

      //check if company exists
      if (data.workspaceUrl) {
        fetch(`${baseUrl}/company?company=${data.workspaceUrl}`)
          .then((r) => r.json())
          .then((r) => {
            this.error = "";

            //set company and company full values
            this.$store.state.company = data.workspaceUrl;
            this.$store.state.company_full = r;

            this.$store.state.company_full.billing = this.checkBilling(
              data.workspaceUrl
            );

            Vue.prototype.$axios.defaults.params["company"] =
              this.$store.state.company;

            this.$router.push(`/${data.workspaceUrl}`);

            setDocTitle("", this);

            setup(false, data.workspaceUrl);
          })
          .catch((e) => {
            this.error = "Workspace not found";
          });
      }
      //
    },
  },
};
